import React from 'react';
import { levelTracks } from '../data/content';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
export function Levels() {
  return <section id="levels" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-156" data-mp="2waaj7kxwvik6">
      <div className="mx-auto max-w-6xl" data-id="element-157" data-mp="2hja1epb9ycbd">
        <SectionHeading eyebrow="Niveles de competencia" title={<>
              Un sistema diseñado para la{' '}
              <span className="text-brand" data-id="element-159" data-mp="28ilvyizy5ka3">realidad de tu colegio</span>
            </>} subtitle="Sabemos que cada institución tiene su propia estructura. Por eso INGLES LISTO abandona las etiquetas rígidas y se organiza por Niveles de Competencia Progresiva: eliges el tomo exacto según el nivel real de tus alumnos." data-id="element-158" data-mp="2mid80e6wkqlg" />

        <div className="mt-14 grid gap-5 lg:grid-cols-2" data-id="element-160" data-mp="23kk5hd06yiol">
          {levelTracks.map((track, index) => {
          const isFirst = index === 0;
          return <Reveal key={track.range} delay={index * 0.06} className="h-full" data-id="element-161" data-mp="1sfj0h1godl9" data-mpi={index}>
                <article className={`flex h-full flex-col rounded-3xl border-2 border-ink p-8 sm:p-10 ${isFirst ? 'bg-bone' : 'bg-ink'}`} data-id="element-162" data-mp="1q1n65yyixcn">
                  <p className={`font-display text-sm tracking-[0.16em] ${isFirst ? 'text-brand' : 'text-volt'}`} data-id="element-163" data-mp="1xiyioab2wcrx">
                    {track.range}
                  </p>
                  <h3 className={`mt-3 font-display text-3xl leading-none sm:text-4xl ${isFirst ? 'text-ink' : 'text-white'}`} data-id="element-164" data-mp="277zurpei6a0m">
                    {track.title}
                  </h3>

                  <ul className="mt-7 grid grid-cols-6 gap-2" data-id="element-165" data-mp="1jk8l6tkckb31">
                    {track.tomos.map(tomo => <li key={tomo} className={`flex h-14 flex-col items-center justify-center rounded-lg font-display text-lg leading-none ${isFirst ? 'bg-ink text-volt' : 'bg-brand text-white'}`} data-id="element-166" data-mp="1elf64wpewc0r">
                        {tomo}
                        <span className="mt-1 font-sans text-[9px] font-bold uppercase tracking-[0.1em] opacity-75" data-id="element-167" data-mp="33xz59pe7rilu">
                          Tomo
                        </span>
                      </li>)}
                  </ul>

                  <p className={`mt-7 text-base leading-relaxed ${isFirst ? 'text-ink/70' : 'text-white/70'}`} data-id="element-168" data-mp="1wkongzltxes9">
                    {track.text}
                  </p>
                </article>
              </Reveal>;
        })}
        </div>
      </div>
    </section>;
}